export default __webpack_public_path__ + "static/client2-39ece585f0a1b0330c627171786c78b7.jpg";